/**
 * A scroll behavior that always scrolls to the top of the page
 * after a transition.
 */
"use strict";

var ScrollToTopBehavior = {

  updateScrollPosition: function updateScrollPosition() {
    window.scrollTo(0, 0);
  }

};

module.exports = ScrollToTopBehavior;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/lib/behaviors/ScrollToTopBehavior.js
 ** module id = 554
 ** module chunks = 0
 **/